import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import EditTableModal from 'widgets/tables/editTableModal';
import React, { useContext, useState } from 'react';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { useTranslation } from 'react-i18next';
import DeleteTableModalController, {
  DeleteTableModalControllerActions,
} from 'widgets/tables/deleteTableModalController';
import ErrorModal from 'shared/lib/components/modals/errorModal';
import { AxiosError } from 'axios';
import { BackErrors } from 'shared/lib/utils/globalUtils';
import {
  TableUpdatable,
  UpdateTableHelper,
} from 'entities/table/model/updateTableHelper';
import { tablesApi } from 'entities/table/api/tablesApi';

export type EditTableAfterReactions = {
  afterTableUpdate?: (updatable: TableUpdatable) => void;
} & DeleteTableModalControllerActions;

export default observer(function EditTableModalController({
  updatable,
  afterTableDelete,
  afterTableUpdate,
  handleClose,
}: {
  updatable: TableUpdatable;
  handleClose: () => void;
} & EditTableAfterReactions) {
  const [isDeleting, setIsDeleting] = useState(false);
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  const [isDublicateError, setIsDublicateError] = useState(false);

  return (
    <>
      <EditTableModal
        isOpen={true}
        handleClose={handleClose}
        initialSectionId={updatable.section_id || null}
        initialFolderId={updatable.folder_id || null}
        tableName={updatable.name || ''}
        onDelete={() => setIsDeleting(true)}
        onSubmit={async (params) => {
          try {
            const links = await tablesApi.fetchLinks(updatable.id, {
              in_trash: null,
            });

            const updateHelper = new UpdateTableHelper(updatable);

            await updateHelper.update({
              id: updatable.id,
              name: params.name,
              folder_id: params.folderId,
              section_id: params.sectionId,
              links,
            });

            afterTableUpdate && afterTableUpdate(updatable);
          } catch (e) {
            const err = e as AxiosError<{ detail?: string }>;

            console.error(err);

            if (
              err?.response?.status === 400 &&
              err?.response?.data?.detail === BackErrors.TableExists
            ) {
              setIsDublicateError(true);
              return;
            }

            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
          }

          handleClose();
        }}
      ></EditTableModal>

      {isDeleting && (
        <DeleteTableModalController
          id={updatable.id}
          handleClose={() => {
            setIsDeleting(false);
            handleClose();
          }}
          afterTableDelete={afterTableDelete}
        ></DeleteTableModalController>
      )}

      {isDublicateError && (
        <ErrorModal
          mainText="Ошибка действия"
          isOpen={true}
          onClose={() => setIsDublicateError(false)}
        >
          <Typography variant="f18" sx={{ fontWeight: 300 }}>
            Действие невозможно&nbsp;&mdash; объект с&nbsp;таким названием уже
            существует по&nbsp;указанному адресу
          </Typography>
        </ErrorModal>
      )}
    </>
  );
});
